// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1IWnz","list":"BalanceDue_list__3lODx","listRow":"BalanceDue_listRow__uFEOF","total":"BalanceDue_total__2GPjw"};